import { useSelector } from 'react-redux';
import { FeatureFlags } from '../feature-flags';

export const useAreFeatureFlagsReady = () => {
  const featureFlags = useSelector((state) => state.featureFlags);
  const featureFlagService = new FeatureFlags({ featureFlags });

  return featureFlagService.areFeatureFlagsReady();
};
